import React from "react";
import Layout from "../components/Layout";
import CollectionsList from "../components/CollectionsList";
import SEO from "../components/SEO.jsx"; 

function Collections() {
  return (
    <Layout>
      <SEO
        title="Shop Collections | This Belongs To"
        description="Browse all This Belongs To collections — bralettes, knickers, swimwear, clothing and accessories."
        path="/home"
        image="/og.jpg"
      />
      <CollectionsList />
    </Layout>
  );
}

export default Collections;
